/** 適正入賞Sチェック用の平日/土日祝。1=平日、2=土日祝 */
export type HeiKyuKbn = '1' | '2';

/** 適正入賞Sチェック用のランク帯。1=低、2=中、3=高 */
export type SisNyushoSRank = 1 | 2 | 3;

/**
 * DK-SISの検索条件の型
 */
export type DkSisSearchParams = {
  sisDateRangeType?: 'monthly' | 'weekly' | 'daily';
  sisStartDate?: string;
  sisEndDate?: string;
  sisBreakEvenForPachinko?: string;
  sisBreakEvenForPachislo?: string;
  sisRank?: string;
  sisArea?: string;
  sisFieldTypes?: string[];
  needsSis?: boolean;
  containsSisAverage?: boolean;
  /**
   * 上限・下限入賞Sの平日/土日祝。従来の損益分岐・ランク・エリアと併用できる
   */
  heiKyuKbn?: HeiKyuKbn;
  /**
   * 上限・下限入賞Sの損益分岐（パチンコ）。値は sisBreakEvenForPachinko と同じ
   */
  sisNyushoSBreakEvenForPachinko?: string;
  /**
   * 上限・下限入賞Sのランク帯。従来の sisRank と併用できる
   */
  sisNyushoSRank?: SisNyushoSRank;
};

/**
 * DK-SISの損益分岐のパチンコの項目
 */
export const SisBreakEvenForPachinkoOption = [
  {
    value: '01',
    label: '16割以上',
  },
  {
    value: '02',
    label: '15割',
  },
  {
    value: '03',
    label: '14割',
  },
  {
    value: '04',
    label: '13割',
  },
  {
    value: '05',
    label: '12割',
  },
  {
    value: '06',
    label: '11割',
  },
  {
    value: '07',
    label: '10割',
  },
];

/**
 * DK-SISの損益分岐のパチスロの項目
 */
export const SisBreakEvenForPachisloOption = [
  {
    value: '01',
    label: '13割以上',
  },
  {
    value: '02',
    label: '12割',
  },
  {
    value: '03',
    label: '11割',
  },
  {
    value: '04',
    label: '10割',
  },
];

/**
 * 上限・下限入賞S用の平日/土日祝
 */
export const HeiKyuKbnOption: { value: HeiKyuKbn; label: string }[] = [
  { value: '1', label: '平日' },
  { value: '2', label: '土日祝' },
];

/**
 * 上限・下限入賞S用のランク帯。表示順は高・中・低
 */
export const SisNyushoSRankOption: { value: SisNyushoSRank; label: string }[] =
  [
    { value: 3, label: '高ランク（種別ランク8〜10）' },
    { value: 2, label: '中ランク（種別ランク4〜7）' },
    { value: 1, label: '低ランク（種別ランク1〜3）' },
  ];

const HEI_KYU_KBN_SET = new Set<string>(
  HeiKyuKbnOption.map((item) => item.value)
);

export const isHeiKyuKbn = (value: string): value is HeiKyuKbn =>
  HEI_KYU_KBN_SET.has(value);

const SIS_NYUSHO_S_RANK_BY_VALUE = {
  '1': 1,
  '2': 2,
  '3': 3,
} as const;

export const toSisNyushoSRank = (value: string): SisNyushoSRank | undefined => {
  if (value === '1' || value === '2' || value === '3') {
    return SIS_NYUSHO_S_RANK_BY_VALUE[value];
  }
  return undefined;
};

/**
 * DK-SISのランクの項目
 */
export const SisRankOption = [
  {
    value: '10',
    label: '10点',
  },
  {
    value: '9',
    label: '9点',
  },
  {
    value: '8',
    label: '8点',
  },
  {
    value: '7',
    label: '7点',
  },
  {
    value: '6',
    label: '6点',
  },
  {
    value: '5',
    label: '5点',
  },
  {
    value: '4',
    label: '4点',
  },
  {
    value: '3',
    label: '3点',
  },
  {
    value: '2',
    label: '2点',
  },
  {
    value: '1',
    label: '1点',
  },
];

/**
 * DK-SISのエリアの項目
 */
export const SisAreaOption = [
  {
    value: '01',
    label: '北海道地区',
  },
  {
    value: '02',
    label: '東北地区',
  },
  {
    value: '03',
    label: '北関東地区',
  },
  {
    value: '04',
    label: '南関東地区',
  },
  {
    value: '05',
    label: '東京地区',
  },
  {
    value: '06',
    label: '北陸甲信越地区',
  },
  {
    value: '07',
    label: '東海地区',
  },
  {
    value: '08',
    label: '近畿地区',
  },
  {
    value: '09',
    label: '中国地区',
  },
  {
    value: '10',
    label: '四国地区',
  },
  {
    value: '11',
    label: '九州沖縄地区',
  },
];
